import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import COLORS from '@mlb/react-patterns/style/universal.color';
import FONTS from '@mlb/react-patterns/style/fonts';

import { mainCq } from 'bdvp-common/src/styles/helpers/main-cq';

const Container = styled.h1`
    width: 80%;
    margin-bottom: 0;
    color: ${COLORS.mlbWhite};
    font-family: ${FONTS.primaryFont};
    font-size: 20px;
    font-style: normal;
    font-stretch: normal;
    font-weight: 700;
    line-height: 1;
    letter-spacing: normal;
    ${mainCq.md`
        width: 70%;
        max-width: 600px;
    `}
`;

const Title = ({
    children,
}) => {

    if(!children) {

        return null;

    }

    return (
        <Container>
            {children}
        </Container>
    );

};

Title.propTypes = {
    children: PropTypes.node,
};

export default Title;
